import { Item } from '@teetsh/app/src/types/programmations';

export function isElementEmpty(item?: Partial<Item>) {
  if (!item) {
    return true;
  }
  const { value, attachments, sequence, ficheDePrep } = item;
  return !value && !attachments?.length && !sequence && !ficheDePrep;
}
